// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_REQUEST_DK = 'FETCH_YARN_PO_REQUEST_DK';
export const FETCH_YARN_PO_SUCCESS_DK = 'FETCH_YARN_PO_SUCCESS_DK';
export const FETCH_YARN_PO_FAILURE_DK = 'FETCH_YARN_PO_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_INVOICE_REQUEST_DK = 'FETCH_YARN_PO_INVOICE_REQUEST_DK';
export const FETCH_YARN_PO_INVOICE_SUCCESS_DK = 'FETCH_YARN_PO_INVOICE_SUCCESS_DK';
export const FETCH_YARN_PO_INVOICE_FAILURE_DK = 'FETCH_YARN_PO_INVOICE_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_WITHOUT_FILTER_REQUEST_DK = 'FETCH_YARN_PO_WITHOUT_FILTER_REQUEST_DK';
export const FETCH_YARN_PO_WITHOUT_FILTER_SUCCESS_DK = 'FETCH_YARN_PO_WITHOUT_FILTER_SUCCESS_DK';
export const FETCH_YARN_PO_WITHOUT_FILTER_FAILURE_DK = 'FETCH_YARN_PO_WITHOUT_FILTER_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_SECTION_LIST_REQUEST_DK = 'FETCH_YARN_PO_SECTION_LIST_REQUEST_DK';
export const FETCH_YARN_PO_SECTION_LIST_SUCCESS_DK = 'FETCH_YARN_PO_SECTION_LIST_SUCCESS_DK';
export const FETCH_YARN_PO_SECTION_LIST_FAILURE_DK = 'FETCH_YARN_PO_SECTION_LIST_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_SUPPLIER_LIST_REQUEST_DK = 'FETCH_YARN_PO_SUPPLIER_LIST_REQUEST_DK';
export const FETCH_YARN_PO_SUPPLIER_LIST_SUCCESS_DK = 'FETCH_YARN_PO_SUPPLIER_LIST_SUCCESS_DK';
export const FETCH_YARN_PO_SUPPLIER_LIST_FAILURE_DK = 'FETCH_YARN_PO_SUPPLIER_LIST_FAILURE_DK';

export const FETCH_YARN_PO_SUPPLIER_LIST2_REQUEST_DK = 'FETCH_YARN_PO_SUPPLIER_LIST2_REQUEST_DK';
export const FETCH_YARN_PO_SUPPLIER_LIST2_SUCCESS_DK = 'FETCH_YARN_PO_SUPPLIER_LIST2_SUCCESS_DK';
export const FETCH_YARN_PO_SUPPLIER_LIST2_FAILURE_DK = 'FETCH_YARN_PO_SUPPLIER_LIST2_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_UNIT_LIST_REQUEST_DK = 'FETCH_YARN_PO_UNIT_LIST_REQUEST_DK';
export const FETCH_YARN_PO_UNIT_LIST_SUCCESS_DK = 'FETCH_YARN_PO_UNIT_LIST_SUCCESS_DK';
export const FETCH_YARN_PO_UNIT_LIST_FAILURE_DK = 'FETCH_YARN_PO_UNIT_LIST_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_PROGRAM_LIST_REQUEST_DK = 'FETCH_YARN_PO_PROGRAM_LIST_REQUEST_DK';
export const FETCH_YARN_PO_PROGRAM_LIST_SUCCESS_DK = 'FETCH_YARN_PO_PROGRAM_LIST_SUCCESS_DK';
export const FETCH_YARN_PO_PROGRAM_LIST_FAILURE_DK = 'FETCH_YARN_PO_PROGRAM_LIST_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_SALES_ORDER_REQUEST_DK = 'FETCH_YARN_PO_SALES_ORDER_REQUEST_DK';
export const FETCH_YARN_PO_SALES_ORDER_SUCCESS_DK = 'FETCH_YARN_PO_SALES_ORDER_SUCCESS_DK';
export const FETCH_YARN_PO_SALES_ORDER_FAILURE_DK = 'FETCH_YARN_PO_SALES_ORDER_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_REQUEST_DK = 'FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_REQUEST_DK';
export const FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_SUCCESS_DK = 'FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_SUCCESS_DK';
export const FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_FAILURE_DK = 'FETCH_YARN_PO_STYLE_NUMBER_BY_SO_ID_FAILURE_DK';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_YARN_PO_REQUEST_DK = 'CREATE_YARN_PO_REQUEST_DK';
export const CREATE_YARN_PO_SUCCESS_DK = 'CREATE_YARN_PO_SUCCESS_DK';
export const CREATE_YARN_PO_FAILURE_DK = 'CREATE_YARN_PO_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_YARN_PO_DK = 'CREATE_USER_FORM_YARN_PO_DK';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_YARN_PO_REQUEST_DK = 'UPDATE_YARN_PO_REQUEST_DK';
export const UPDATE_YARN_PO_SUCCESS_DK = 'UPDATE_YARN_PO_SUCCESS_DK';
export const UPDATE_YARN_PO_FAILURE_DK = 'UPDATE_YARN_PO_FAILURE_DK';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_YARN_PO_REQUEST_DK = 'FETCH_SINGLE_YARN_PO_REQUEST_DK';
export const FETCH_SINGLE_YARN_PO_SUCCESS_DK = 'FETCH_SINGLE_YARN_PO_SUCCESS_DK';
export const FETCH_SINGLE_YARN_PO_FAILURE_DK = 'FETCH_SINGLE_YARN_PO_FAILURE_DK';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_YARN_PO_REQUEST_DK = 'DELETE_YARN_PO_REQUEST_DK';
export const DELETE_YARN_PO_SUCCESS_DK = 'DELETE_YARN_PO_SUCCESS_DK';
export const DELETE_YARN_PO_FAILURE_DK = 'DELETE_YARN_PO_FAILURE_DK';

// USERFORM RESET_DK

export const YARN_PO_USERFORM_RESET_DK = 'YARN_PO_USERFORM_RESET_DK';

// navigate to unit component
export const NAVIGATE_YARN_PO_DETAILS_DK = 'NAVIGATE_YARN_PO_DETAILS_DK';
// navigate to company component
export const NAVIGATE_YARN_PO_DK = 'NAVIGATE_YARN_PO_DK';
export const YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK = 'YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK';
export const YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK = 'YARN_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB_REVERSE_DK';

export const RESET_YARN_PO_INVOICE_DK = 'RESET_DK_YARN_PO_INVOICE_DK';

export const DELETE_BTN_UPDATE_API_REQUEST_DK = 'DELETE_BTN_UPDATE_API_REQUEST_DK';
export const DELETE_BTN_UPDATE_API_SUCCESS_DK = 'DELETE_BTN_UPDATE_API_SUCCESS_DK';
export const DELETE_BTN_UPDATE_API_FAILURE_DK = 'DELETE_BTN_UPDATE_API_FAILURE_DK';

export const SET_UNIT_NAME_YARN_PO_DK = 'SET_UNIT_NAME_YARN_PO_DK';
